import { Injectable } from "@angular/core";
import { TelemetryService } from "@obg/ngx.global.evo";

import { welcomeFlowABTest } from "./welcome-flow.const";

@Injectable({ providedIn: "root" })
export class WelcomeFlowService {
	constructor(private telemetryService: TelemetryService) {}

	triggerABTestEvent(): void {
		this.telemetryService.track({
			event: welcomeFlowABTest.event,
			LoginType: welcomeFlowABTest.loginType,
		});
	}
}
